export const marketKeys = {
  all: (storeId: string) => ['stores', storeId, 'markets'] as const,
  list: (storeId: string) => [...marketKeys.all(storeId), 'list'] as const,
  /** Organisation-wide, not per store. */
  exchangeRates: () => ['org', 'exchange-rates'] as const,
};
